<div class="tecbazar-block-a" *ngIf="bannerSlots.length">
  <div class="tecbazar-banners__grid" role="list">
    <div
      class="tecbazar-banner-slot"
      *ngFor="let banner of bannerSlots; trackBy: trackByBannerId"
      role="listitem">
      <div class="tecbazar-banner-slot__frame">
        <img
          class="tecbazar-banner-slot__img"
          [defaultImage]="bannerPlaceholder"
          [lazyLoad]="banner.src"
          [attr.alt]="banner.alt"
          loading="lazy"
        />
      </div>
    </div>
  </div>
</div>
